import { useQuery } from '@tanstack/react-query';
import { getAgencies } from '../../api/apiAgencies';

export const useGetAgencies = (params = {}) => {
    return useQuery({
        queryKey: ['agencies', params],
        queryFn: () => getAgencies(params),
        staleTime: 5 * 60 * 1000, // 5 minutes
    });
};
